import React from "react";

import PropTypes from "prop-types";

export default function Badge({ color, children }) {
  let className = "";
  switch (color) {
    default:
    case "primary":
      className = "bg-primary/30 text-white";
      break;
    case "secondary":
      className = "bg-secondary/30 text-secondary";
      break;
    case "tertiary":
      className = "bg-tertiary/30 text-tartiary";
      break;
    case "success":
      className = "bg-success/30 text-success";
      break;
    case "info":
      className = "bg-info/30 text-info";
      break;
    case "warning":
      className = "bg-warning/30 text-warning";
      break;
    case "danger":
      className = "bg-danger/30 text-danger";
      break;
    case "dark":
      className = "bg-dark/30 text-white";
      break;
    case "light":
      className = "bg-light/30 text-light";
      break;
  }

  return (
    <div className={`${className} px-2 py-1 w-fit rounded text-sm`}>
      {children}
    </div>
  );
}

Badge.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "success",
    "info",
    "warning",
    "danger",
    "dark",
    "link",
    "light",
  ]),
  children: PropTypes.node.isRequired,
};

Badge.defaultProps = {
  color: "primary",
};
